import React from "react";
import { makeStyles } from "@material-ui/core";
import { useHistory } from "react-router-dom";

let useStyles = makeStyles((theme) => ({
  root: {
    ...theme.grid.gridMdContent,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    textAlign: "center",
    flexDirection: "column",
    margin: "70px auto",
    maxWidth: "100%",
  },
  gridDesc: {
    width: "50%",
    minWidth: 700,
    maxWidth: "100%",
    margin: "auto",
    [theme.breakpoints.down("800")]: {
      minWidth: "100%",
    },
  },
  desc: {
    margin: 0,
    fontSize: 16,
  },
  gridBtns: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "25px",
    [theme.breakpoints.down("375")]: {
      flexDirection: "column",
      width: "100%",
      "& > button": {
        width: "90%",
      },
    },
  },
  linkBtnRed: {
    "@media (max-width: 375px)": {
      width: "90%",
    },
  },
  btnRed: {
    margin: 5,
    "@media (max-width: 375px)": {
      width: "100%",
      margin: "5px 0px",
    },
  },
  btnWhite: {
    margin: 5,
    padding: "0px 33.5px",
  },
}));

export default function Index() {
  let classes = useStyles();
  let history = useHistory();

  const handelRoute = (path) => {
    window.scrollTo(0, 0);
    history.push(path);
  };
  return (
    <div className={classes["root"]}>
      <div className={classes["gridDesc"]}>
        <p className={classes["desc"]}>
          سرمایه‌گذاری در بورس به معنای خرید و فروش اوراق بهادار و سهام شرکت‌ها
          با هدف کسب سود است. بورس یک بازار مالی است که در آن افراد و شرکت‌ها
          می‌توانند اوراق بهادار را خرید و فروش کنند.
        </p>
        <p className={classes["desc"]}>
          برای سرمایه‌گذاران، این فرصت فراهم می‌شود تا با تحلیل و بررسی اطلاعات
          مربوط به شرکت‌ها و بازار، سرمایه خود را در سهام یا دیگر اوراق بهادار
          سرمایه‌گذاری کنند. سود حاصل از این سرمایه‌گذاری ممکن است از افزایش
          قیمت سهام، تقسیم سود شرکت، یا افزایش ارزش سایر اوراق بهادار باشد.
        </p>
      </div>
      <div className={classes["gridBtns"]}>
        <a
          href="https://reg.pouyanbroker.ir"
          target={"_blank"}
          className={classes["linkBtnRed"]}
        >
          <button type="" className={`${classes["btnRed"]} btnPouyanRed`}>
            ثبت نام در بورس
          </button>
        </a>
        <button
          type=""
          className={`${classes["btnWhite"]} btnPouyanWhite`}
          // onClick={() => handelRoute('/kala')}
        >
          اطلاعات بیشتر
        </button>
      </div>
    </div>
  );
}
